import React from 'react'
import Alert from 'sprockets_react/job_wizards/components/Alert'
import Eula from 'sprockets_react/job_wizards/components/Eula'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'
import passwordlessImage from 'passwordless.png'

JobWizard.Password = class Password extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      passwordless: null,
      showOtpField: false,
      showCreatePassword: false,
      showOtpMessageError: false,
      showNewPassword: false,
      showConfirmPassword: false,
      loadingSms: false,
      loadingEmail: false,
      loadingSubmit: false,
      alertMessage: '',
      messageClass: '',
      otp: null,
      validMobileNumber: false,
      newPassword: '',
      confirmPassword: '',
      lastOtpMethod: null,
      passwordValidationError: ''
    }
    this.handleOnclickResetPassword = this.handleOnclickResetPassword.bind(this)
    this.handleSendEmail = this.handleSendEmail.bind(this)
    this.handleSendSms = this.handleSendSms.bind(this)
    this.handleOnclickSubmitCode = this.handleOnclickSubmitCode.bind(this)
    this.handleToggleNewPassword = this.handleToggleNewPassword.bind(this)
    this.handleToggleConfirmPassword = this.handleToggleConfirmPassword.bind(this)
    this.handlePasswordChange = this.handlePasswordChange.bind(this)
    this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this)
    this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this)
    this.handleExternalError = this.handleExternalError.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  componentDidMount() {
    this.checkIfPasswordless()
    $('#modal-nav-right-button').addClass('disabled')
    JobWizard.Emitter.addListener('job:wizard:passwordError', this.handleExternalError)
  }

  componentWillUnmount() {
    $('#modal-nav-right-button').removeClass('disabled')
    JobWizard.Emitter.removeListener('job:wizard:passwordError', this.handleExternalError)
  }

  handleExternalError(msg) {
    this.setState({ passwordValidationError: msg })
  }

  setupValidation() {
    JobWizard.Validator.addField("password", {
      validators: {
        notEmpty: {
          message: "Please enter your password"
        },
        blank: {}
      }
    })
  }

  checkIfPasswordless() {
    $.ajax(SS.API.V3.userCheckEmail(Job.Data.emailAddress)).fail(function () {
      document.location = "/500"
    }).done((response) => {
      const data = response.meta

      SS.userPhoneIsValid = data.validMobileNumber === true
      SS.userPhoneVerified = data.verifiedPhone === true

      if (data.passwordless === true) {
        this.setState({ passwordless: true, validMobileNumber: data.validMobileNumber })
      } else {
        this.setState({ passwordless: false, validMobileNumber: data.validMobileNumber })
      }
      this.setupValidation()
    })
  }

  handleOnclickResetPassword() {
    SS.userPhoneIsValid = false
    SS.userPhoneVerified = false
    this.setState({ passwordless: null, showSendResetPassword: true })
  }

  handleSendEmail() {
    $.ajax($.extend(SS.API.V3.userPinSend({ email: Job.Data.emailAddress, channel: 'email' }), {
      beforeSend: () => {
        this.setState({ loadingEmail: true })
      }
    })).done((data) => {
      this.setState({
        alertMessage: 'Please check your email—we’ve sent you the code to create a password.',
        messageClass: 'alert-success',
        loadingEmail: false,
        showOtpField: true,
        passwordless: null,
        lastOtpMethod: 'email'
      })
    })
  }

  handleSendSms() {
    $.ajax($.extend(SS.API.V3.userPinSend({ email: Job.Data.emailAddress, channel: 'sms' }), {
      beforeSend: () => {
        this.setState({ loadingSms: true })
      }
    })).done((data) => {
      this.setState({
        alertMessage: 'Please check your SMS—we’ve sent instructions to create your password.',
        messageClass: 'alert-success',
        loadingSms: false,
        showOtpField: true,
        passwordless: null,
        lastOtpMethod: 'sms'
      })
    })
  }

  handleOnclickSubmitCode() {
    let otp = $('#otp').val()
    $.ajax($.extend(SS.API.V3.userPinValidate({ email: Job.Data.emailAddress, pin: otp }), {
      beforeSend: () => {
        this.setState({ loadingSubmit: true })
      }
    })).done((data) => {
      if (data.meta.valid === true) {
        this.setState({
          showOtpMessageError: false,
          showCreatePassword: true,
          showOtpField: false,
          alertMessage: ''
        })
        Job.Actions.updateOtp(otp)
      } else {
        this.setState({ showOtpMessageError: true })
      }
    })
  }

  handleToggleNewPassword() {
    this.setState({ showNewPassword: !this.state.showNewPassword })
  }

  handleToggleConfirmPassword() {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword })
  }

  handlePasswordChange() {
    $('.reset-password').css('marginRight', '0px')
    $('.incorrect-password').addHidden()
    $('#modal-nav-right-button').removeClass('disabled')
  }

  handleNewPasswordChange(e) {
    this.setState(
      { newPassword: e.target.value },
      () => {
        this.toggleSubmitButton()
      }
    )
  }

  handleConfirmPasswordChange(e) {
    this.setState(
      { confirmPassword: e.target.value },
      () => {
        this.toggleSubmitButton()
      }
    )
  }

  validatePasswords(field = null) {
    const { newPassword, confirmPassword } = this.state
    let error = ''

    if (newPassword && newPassword.length < 6) {
      error = 'Password is too short (min 6 characters).'
    } else if (newPassword && newPassword.length > 40) {
      error = 'Password is too long (max 40 characters).'
    } else if (field === 'confirm' && newPassword !== confirmPassword) {
      error = 'Passwords do not match.'
    }

    return error === ''
  }

  toggleSubmitButton() {
    const { newPassword, confirmPassword } = this.state
    const isValid = newPassword.length > 0 && confirmPassword.length > 0

    if (isValid) {
      $('#modal-nav-right-button').removeClass('disabled')
    } else {
      $('#modal-nav-right-button').addClass('disabled')
    }
  }

  renderSendEmailOption() {
    return (
      <button
        className="btn btn-block btn-secondary radius-6 mt20 normal"
        onClick={this.handleSendEmail}>
        {this.state.loadingEmail ? <span className="spinner-icon "/> : 'Get a code via “Email”'}
      </button>
    )
  }

  renderSendSmsOption() {
    if (Job.Data.phoneNumber !== null && this.state.validMobileNumber) {
      return (
        <div>
          <div className="flex items-center mt12">
            <span className="border-top width-100 mr8"></span>
            OR
            <span className="border-top width-100 ml8"></span>
          </div>
          <p className="mb10 mt10 fs14">Send an SMS to { Job.Data.phoneNumber }</p>
          <button
            className="btn btn-block btn-clear btn-secondary radius-6 normal"
            onClick={this.handleSendSms}>
            { this.state.loadingSms ? <span className="spinner-icon "/> : 'Get a code via “SMS”' }
          </button>
        </div>
      )
    }
  }

  renderAlertMessage() {
    if (this.state.alertMessage !== '') {
      return (
        <div className={`alert ${this.state.messageClass} flex items-center`}><i className='ficon-check-circle mr12'/>{this.state.alertMessage}</div>
      )
    }
  }

  renderOtpField() {
    if (this.state.showOtpField) {
      return (
        <div>
          <p className="mb4 mt20">Enter code:</p>
          <div className="input-group">
            <span>
              <input
                type="text"
                name="otp"
                id="otp"
                className="form-control"
              />
            </span>
            <span className="input-group-btn">
              <a href="#" className="btn btn-block btn-main" onClick={this.handleOnclickSubmitCode}>Submit</a>
            </span>
          </div>
          { this.state.showOtpMessageError &&
            <div className="help-block text-red">Wrong code. Try again.</div>
          }
          <div className="fs14 mt8 text-center">
            {this.state.lastOtpMethod === 'email' && (
              <div>
                <span>Didn’t receive an email?</span>
                <a className="text-secondary bold underline cursor-pointer ml4 text-underline" onClick={this.handleSendEmail}>
                  { this.state.loadingEmail ? <span className="spinner-icon "/> : 'Send again' }
                </a>
              </div>
            )}
            {this.state.lastOtpMethod === 'sms' && (
              <div>
                <span>Didn’t receive an SMS?</span>
                <a className="text-secondary bold underline cursor-pointer ml4 text-underline" onClick={this.handleSendSms}>
                  { this.state.loadingSms ? <span className="spinner-icon "/> : 'Send again' }
                </a>
              </div>
            )}
          </div>
        </div>
      )
    }
  }

  renderCreatePasswordField() {
    if (this.state.showCreatePassword) {
      return (
        <div>
          <h3 className="mb15 text-center">Create your password</h3>
          { this.state.passwordValidationError &&         
            <Alert
              message={this.state.passwordValidationError}
              classNames='p12 password-validation-error'
              type='danger'
            />
          }
          <div>
            <label className="mb4 bold-500">New password</label>
            <div className="input-with-icon relative">
              <input
                type={this.state.showNewPassword ? 'text' : 'password'}
                name="new-password"
                id="new-password"
                className="form-control"
                value={this.state.newPassword}
                onChange={this.handleNewPasswordChange}
              />
              <button type="button" onClick={this.handleToggleNewPassword}>
                <i
                  className={`absolute ${this.state.showNewPassword ? 'fs18 ficon-no-views' : 'fs12 ficon-views_icon'} text-copy-1`}
                  style={{
                    top: this.state.showNewPassword ? '16%' : '23%',
                    right: this.state.showNewPassword ? '15px' : '20px'
                  }}
                />
              </button>
            </div>
          </div>

          <div>
            <label className="mb4 bold-500">Confirm new password</label>
            <div className="input-with-icon relative">
              <input
                type={this.state.showConfirmPassword ? 'text' : 'password'}
                name="confirm-password"
                id="confirm-password"
                className="form-control"
                value={this.state.confirmPassword}
                onChange={this.handleConfirmPasswordChange}
              />
              <button type="button" onClick={this.handleToggleConfirmPassword}>
                <i
                  className={`absolute ${this.state.showConfirmPassword ? 'fs18 ficon-no-views' : 'fs12 ficon-views_icon'} text-copy-1`}
                  style={{
                    top: this.state.showConfirmPassword ? '16%' : '23%',
                    right: this.state.showConfirmPassword ? '15px' : '20px'
                  }}
                />
              </button>
            </div>
          </div>
        </div>
      )
    }
  }

  renderPasswordlessMessage() {
    if (this.state.passwordless === true) {
      return (
        <span>
          <img
            src={passwordlessImage}
            className="col-centered mb16 radius-6"
            style={{ height: '87px' }}
          />
          You need to create a password to continue. Your account setup isn’t complete yet—please set a password to proceed.
          <br />
          {this.renderSendEmailOption()}
          {this.renderSendSmsOption()}
        </span>
      )
    }
  }

  renderExistingPasswordMessage() {
    if (this.state.passwordless === false) {
      return (
        <span>
          We've found your existing account! Please enter your password to login and proceed.
        </span>
      )
    }
  }

  renderSendCodeOptions() {
    if (this.state.showSendResetPassword && !this.state.showCreatePassword) {
      return (
        <p className="grey-box p10 mt10 text-center">
          {this.renderSendEmailOption()}
          {this.renderSendSmsOption()}
        </p>
      )
    }
  }

  renderPasswordField() {
    if (this.state.passwordless === false) {
      return (
        <div>
          <h3 className="mb15 mt20">Login</h3>
          <input
            type="password"
            name="password"
            id="password"
            placeholder="Password"
            className="form-control"
            onChange={this.handlePasswordChange}
          />
        </div>
      )
    }
  }

  renderResetPasswordButton() {
    if (this.state.passwordless === false) {
      return (
        <a href="#"
          className="reset-password pull-right mt5"
          onClick={this.handleOnclickResetPassword}>Reset your password
        </a>
      )
    }
  }

  handleClose() {
    Job.Actions.updateResetEmailAddressSlide(true)
    JobWizard.Emitter.emit('job:wizard:retreatToPreviousStep')
  }
   
  render() {
    return (
      <div>
        <div className="form-group">
          <div className={`${this.state.showSendResetPassword === true ? '' : 'bg-gray-2'} p12 pt16 pb16 mt10`}>
            { this.renderAlertMessage() }
            { this.renderOtpField() }
            { this.renderCreatePasswordField() }
          
            <div className={`text-center ${this.state.passwordless !== null ? '' : 'hidden'}`}>
              <button className={`float-right ${this.state.passwordless === true ? '' : 'hidden'}`} type='button' onClick={this.handleClose}>
                <hero-icon-solid name='x' class='h-4 text-base-gray-text-secondary hover:text-gray-500 cursor-pointer'></hero-icon-solid>
              </button>
              { this.renderPasswordlessMessage() }
              { this.renderExistingPasswordMessage() }
            </div>
          </div>
          { this.renderSendCodeOptions() }
          { Job.Data.omniAuthDetails['oauth_email_exists'] ? (
            <p className="grey-box p10 mt10">
              We will connect your {Job.Data.omniAuthDetails['oauth_provider']} account once you're logged in.
            </p>
          ) : '' }
          { this.renderPasswordField() }
          { this.state.passwordless === false &&
            <span className="inline-block incorrect-password help-block text-red hidden">Incorrect password. Please try again or</span>
          }
          { this.renderResetPasswordButton() }
        </div>
        { Eula.renderApp({ marginTop: "30px", marginBottom: "30px", fontSize: "14px" }) }
      </div>
    )
  }
}
